// IE 2026 10 25 / ODOO-348878 (hotfix: ⚙ шахматки — циклическая ссылка в attr).
// attr — описание (данные): его копируют в записи форм (⚙ «View …»: mainStore копирует все ключи attr, кроме служебных), сериализуют (JSON.stringify в send_widgetOpen),
// обходят рекурсией (remove_keys_in_place). Ссылка на компонент перечислимым ключом замыкает круг (компонент → $props.initialAttr → attr → компонент).
// setAttrBackRef(attr, key, value): служебная обратная ссылка неперечислимым свойством — читается как прежде (attr[key]), но не видна Object.keys / entries / spread / JSON.
export function setAttrBackRef(attr, key, value) {
    if (!attr || typeof attr !== 'object') return attr
    try {
        Object.defineProperty(attr, key, { value, enumerable: false, configurable: true, writable: true })
    } catch (e) {
        attr[key] = value   // неизменяемый объект — как прежде
    }
    return attr
}
